export default {
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    show() {
      this.isVisible = true
    },
    hide() {
      this.isVisible = false
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/common/mixins/api.js